import moment from 'moment'
import Constants from "../../const/Constants";

let UserUtil = {
    getId: function(user: any) {
        return user ? user.id : null
    },
    getPhotoId: function(user: any) {
        return user ? user.photoId : null
    },
    getPhotoUrl: function(user: any) {
        return user && user.photoId && user.photoId > 1 ? `${Constants.queryConst}/file/profile/photo?id=` + user.photoId : '../../../../images/user/user.png'
    },
    getNotificationFlag: function(user: any) {
        return user ? user.notificationFlag === true : false
    },

    getUserNotificationTime: function(user: any) {
        const notificationTime = user.notificationTime
        return notificationTime ? new Date('1970-01-01T' + notificationTime).getHours() + ':00' : '12:00'
    },

    convertHoursToTime: function(hours: number) {
        const m = moment().utcOffset(0)
        m.set({ hour: hours, minute: 0, second: 0, millisecond: 0 })
        return m.format('hh:mm:ss')
    },

    hasPayment: function(user: any) {
        return user && user.hasPayment
    },

    getTelegramChannel: function(user: any) {
        return user && user.telegramChannel ? user.telegramChannel : ''
    }
}
export default UserUtil
